"use strict";

module.exports = function (value) {
	// eslint-disable-next-line no-self-compare
	return value !== value;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/es5-ext/number/is-nan/shim.js
// module id = 510
// module chunks = 0